
function trackServerSide() {
    const HeapTracking = window.Bark.heapTracking = window.Bark.heapTracking || [];

    if(HeapTracking?.length > 0){
        HeapTracking.forEach(item => {
            tracking(item.name, item.value, item.params);
            window.barkTracking.logCustomEvent(
                item.name,
                item.value,
                item.params
            );
        });
    }
}

trackServerSide();



